import { model } from "../core/model";

const resolveSegmentation = () => {
  //TODO: Leer la cookie que corresponda
  let elements = document.getElementsByClassName("combo sg");
  let combos = elements = Array.from(elements); //convert to array
  combos.forEach(element => {
      if (!element.classList.contains("sg-" + model.Usuario.Segmento)) {
      element.remove();
    }
  });
}


module.exports = {
  resolveSegmentation
}


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/handlers/segmentation.js